export const strategi_pengawasan = {
  router: [
    {
      name: "STRATEGI PENGAWASAN",
      key: "strategi_pengawasan",
      path: "/admin/master/strategi-pengawasan",
      apiUrl: {
        data: "master/api/strategi/pengawasan/",
        preview: "master/api/strategi/pengawasan/",
      },
      breadCrumb: [
        {
          label: "MASTER",
          link: "#",
          active: false,
        },
        {
          label: "STRATEGI PENGAWASAN",
          link: "#",
          active: true,
        },
      ],
      component: "datatable1",
    },
  ],
  model: [
    {
      name: "id",
      isPk: true,
      isForm: false,
      isTable: false,
    },
    {
      name: "nama",
      label: "Nama",
      type: "text",
      validation: {
        insert: [
          {
            required: true,
            message: " harus diisi",
          },
        ],
      },
      isForm: true,
      isTable: true,
    },
  ],
};
